(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marina-launch"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__kirsyMarinaEvents) return;
  window.__kirsyMarinaEvents = true;
  const emit = (name, data) => {
    const s = window.Shopify;
    if (s?.designMode || !s?.customerPrivacy?.analyticsProcessingAllowed() || !s?.analytics?.publish) return;
    s.analytics.publish('kirsy:' + name, data);
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-marina-buy]');
    if (link) emit('book_store_click', {book:'marina',edition:link.dataset.marinaBuy,language:document.documentElement.lang});
  });
  document.querySelectorAll('.marina-signup-form').forEach(form => {
    form.addEventListener('submit', () => {
      if (form.checkValidity()) emit('newsletter_request', {campaign:'marina',language:document.documentElement.lang});
    });
  });
  if (document.querySelector('[data-marina-signup-success]')) emit('newsletter_request_accepted', {campaign:'marina',language:document.documentElement.lang});
})();

  } catch(e) { console.error(e); }
})();
})();
